// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_es_mjs":"b102083991f44291","node_modules_canvg_lib_index_es_js":"db05199473810af6"}[chunkId] + ".js";
};